"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TemplateLocations {
}
exports.TemplateLocations = TemplateLocations;
//# sourceMappingURL=TemplateLocations.js.map